var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOurValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3217 4.25684H7.7217C7.36205 4.26671 7.00977 4.36108 6.69335 4.53232C6.37693 4.70356 6.10525 4.94686 5.90027 5.24255L2.00027 10.6426C1.71068 11.0518 1.56605 11.546 1.58935 12.0468C1.61264 12.5476 1.80251 13.0263 2.12884 13.4068L13.8288 26.8854C14.0291 27.1435 14.2858 27.3524 14.5792 27.4961C14.8726 27.6398 15.195 27.7145 15.5217 27.7145C15.8484 27.7145 16.1708 27.6398 16.4642 27.4961C16.7576 27.3524 17.0143 27.1435 17.2146 26.8854L28.9146 13.4068C29.2409 13.0263 29.4308 12.5476 29.4541 12.0468C29.4773 11.546 29.3327 11.0518 29.0431 10.6426L25.1431 5.24255C24.9382 4.94686 24.6665 4.70356 24.3501 4.53232C24.0336 4.36108 23.6814 4.26671 23.3217 4.25684V4.25684Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4073 4.23535L9.17871 12.3354L15.5216 27.6568",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7001 4.23535L21.9072 12.3354L15.5215 27.6568",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63574 12.335H29.4072",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOurValue);
export default __webpack_public_path__ + "static/media/icon-our-value.0fea294d8ab667001923f2b7a211857a.svg";
export { ForwardRef as ReactComponent };